export type Environment = "local" | "dev" | "staging" | "prod";

export const ENV: Environment =
  (process.env.EXPO_PUBLIC_ENV as Environment) ||
  (process.env.NODE_ENV === "development" ? "local" : "prod");

export const isTest = process.env.NODE_ENV === "test";
export const isLocal = ENV === "local";
export const isDev = ENV === "dev";
export const isStaging = ENV === "staging";
export const isProd = ENV === "prod";

export const ENV_PREFIX = isProd ? "" : `${ENV}.`;

// Base URL of the Curai Classic web app, used for the reverse
// "Link your account" deep-link into Classic's account-merge page.
// Locally the Classic web app serves on :8087. Deployed builds must set
// EXPO_PUBLIC_CLASSIC_BASE_URL to the environment-appropriate Classic host.
export const CLASSIC_BASE_URL =
  process.env.EXPO_PUBLIC_CLASSIC_BASE_URL || "http://localhost:8087";
